import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BnyAccount } from '../models/bny-account.model';
import { BnySecurity } from '../models/bny-security.model';

@Injectable()
export class BnyRepository {
  private readonly apiBase = '/api/bny';

  constructor(private http: HttpClient) {}

  getBnySecurities(input: string): Observable<BnySecurity[]> {
    return this.http
      .get<BnySecurity[]>(`${this.apiBase}/securities`, {
        params: { text: input }
      })
      .pipe(
        catchError(error => {
          throw error;
        })
      );
  }

  getBnyEntitledSecurity(): Observable<BnySecurity[]> {
    return this.http.get<BnySecurity[]>(`${this.apiBase}/securities/entitled`).pipe(
      catchError(error => {
        throw error;
      })
    );
  }

  getIsInBnyAccount(): Observable<BnyAccount> {
    return this.http.get<BnyAccount>(`${this.apiBase}/entitlement/is-in-bny-account`).pipe(
      catchError(error => {
        throw error;
      })
    );
  }
}
